<nz-card nzHoverable [nzCover]="coverTemplate" (click)="cardClick.emit()">
  <!-- Card Body: Status row + role tag -->
  <div style="display: flex; flex-direction: column; gap: 4px">
    <div nz-row nzAlign="middle">
      <app-scan-status-icon nz-dropdown nz-col [nzSpan]="6" [status]="scan().state" nzTrigger="hover"
        [nzDropdownMenu]="menu" [modified]="modifiedByUser()">
      </app-scan-status-icon>
      <nz-dropdown-menu #menu="nzDropdownMenu">
        <!-- AC-2: All statuses incl. Bypassed go through onMenuStatusChange — Operator gets popup, others emit directly. -->
        <ul nz-menu nzSelectable>
          <li nz-menu-item (click)="onMenuStatusChange(ScanStatus.Passed)">
            <span nz-icon nzType="check-circle" nzTheme="fill" style="color: green; margin-inline-end: 4px"></span>
            <span i18n>Pass</span>
          </li>
          <li nz-menu-item (click)="onMenuStatusChange(ScanStatus.Failed)">
            <span nz-icon nzType="close-circle" nzTheme="fill" style="color: red; margin-inline-end: 4px"></span>
            <span i18n>Fail</span>
          </li>
          <li nz-menu-item (click)="onMenuStatusChange(ScanStatus.Ignored)">
            <span nz-icon nzType="question-circle" nzTheme="fill" style="color: grey; margin-inline-end: 4px"></span>
            <span i18n>Ignore</span>
          </li>
          <li nz-menu-item (click)="onMenuStatusChange(ScanStatus.Bypassed)">
            <span nz-icon nzType="eye-invisible"></span>
            <span i18n>Bypass</span>
          </li>
        </ul>
      </nz-dropdown-menu>
      <span style="text-align: center" nz-col [nzSpan]="3">
        {{ scan().sequenceInBatch }}
      </span>
      <span nz-col [nzSpan]="13" 
        style="
            text-align: start;
            white-space: nowrap;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            padding: 0 4px;
            margin-inline-start: auto;
            font-weight: bold;
            cursor: pointer;
          " 
        (mouseenter)="showGauges()" 
        (mouseleave)="hideGauges()"
        >
        Δ
        <span [style.color]="dEColor()">{{ scan().dE | number: '1.1-1' }}</span>
        @if (dc() != null) {
        &nbsp;dC:<span [style.color]="dCColor()">{{ dc() | number: '1.1-1' }}</span>
        }
        @if (!inspectionModel()?.isUsingDeltaE) {
        &nbsp;[<span [style.color]="labChannelColors().l">L</span><span
          [style.color]="labChannelColors().a">A</span><span [style.color]="labChannelColors().b">B</span>]
        }
        &nbsp;Ci:{{ scan().ci | number: '1.1-1' }}
      </span>
    </div>
  </div>
</nz-card>

@if (gaugesOpen()) {
  <app-lab-threshold-gauges 
    [predicted]="scan().predicted" 
    [reference]="referenceLab()" 
    [model]="inspectionModel()"
    (mouseenter)="showGauges()" 
    (mouseleave)="hideGauges()" 
    (closed)="gaugesOpen.set(false)"
    >
  </app-lab-threshold-gauges>
}
<ng-template #coverTemplate>
  <div class="cover-layout">
    <!-- Image & Hover Overlay -->
    <div class="image-wrapper" (mouseenter)="hoverStart.emit()" (mouseleave)="hoverEnd.emit()">
      <img nz-image i18n-alt alt="image" [nzSrc]="scan().imageSmallUrl ?? fallbackImage" [nzFallback]="fallbackImage" />
      <div [style.display]="showStats() ? 'flex' : 'none'" class="stats-overlay">
        <div class="color-info camera-row" [style.background]="colorPicker(scan().median)">
          <div i18n class="color-info__title">Camera</div>
          <div class="color-info__label">
            <div>L:</div>
            <div>A:</div>
            <div>B:</div>
          </div>
          <div class="color-info__label color-info__values--right">
            <div>{{ scan().median?.l | number: '1.1-1' }}</div>
            <div>{{ scan().median?.a | number: '1.1-1' }}</div>
            <div>{{ scan().median?.b | number: '1.1-1' }}</div>
          </div>
          <div class="color-info__label color-info__values--right">
            <div>{{ scan().bucketL | number: '1.1-1' }}</div>
            <div>{{ scan().bucketSplash | percent }}</div>
            <div></div>
          </div>
          <div class="color-info__spacer"></div>
        </div>
        <div class="ref-predicted-row" style="margin: 0; display: inline-flex; flex-direction: row; flex-grow: 1">
          <div style="display: inline-flex; flex-grow: 1; flex-direction: column; border: 1px solid black"
            [style.background]="colorPicker(referenceLab())">
            <div class="color-info">
              <div class="color-info__label">
                <div>L:</div>
                <div>A:</div>
                <div>B:</div>
              </div>
              <div class="color-info__label color-info__values--right">
                <div>{{ referenceLab()?.l | number: '1.1-1' }}</div>
                <div>{{ referenceLab()?.a | number: '1.1-1' }}</div>
                <div>{{ referenceLab()?.b | number: '1.1-1' }}</div>
              </div>
              <div class="color-info__spacer"></div>
            </div>
            <div i18n class="color-info-__subscript">Reference</div>
          </div>
          <div style="display: inline-flex; flex-direction: column; flex-grow: 1; border: 1px solid black"
            [style.background]="colorPicker(scan().predicted)">
            <div class="color-info">
              <div class="color-info__label">
                <div>L:</div>
                <div>A:</div>
                <div>B:</div>
              </div>
              <div class="color-info__label color-info__values--right">
                <div>{{ scan().predicted?.l | number: '1.1-1' }}</div>
                <div>{{ scan().predicted?.a | number: '1.1-1' }}</div>
                <div>{{ scan().predicted?.b | number: '1.1-1' }}</div>
              </div>
              @if (referenceLab()?.l && scan().predicted?.l) {
              <div class="color-info__label color-info__values--right">
                <div>({{ deltaLabString(scan().predicted?.l, referenceLab()?.l) }})</div>
                <div>({{ deltaLabString(scan().predicted?.a, referenceLab()?.a) }})</div>
                <div>({{ deltaLabString(scan().predicted?.b, referenceLab()?.b) }})</div>
              </div>
              }
              <div class="color-info__spacer"></div>
            </div>
            <div i18n class="color-info-__subscript">Predicted</div>
          </div>
        </div>
        <div class="scan-meta-info">
          <div nz-row nzJustify="start" nzAlign="middle">
            <button
              i18n
              type="button"
              class="meta-label"
              style="background:none;border:none;padding:0;color:#1677ff;cursor:pointer;text-decoration:underline;font:inherit;"
              (click)="openScanJson($event)"
            >Scanned:</button>
            <span class="meta-value">{{ scan().scannedTime | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
            @if (isAdmin()) {
            <!-- DEV-286 (Admin only): same row as "Scanned:", right after the time; the row wraps in a narrow card. -->
            <button
              i18n
              type="button"
              class="show-tags-link"
              style="background:none;border:none;padding:0;margin-inline-start:8px;white-space:nowrap;color:#1677ff;cursor:pointer;text-decoration:underline;font:inherit;"
              (click)="openScanTags($event)"
            >show tags...</button>
            }
          </div>
          <div nz-row nzJustify="start" nzAlign="middle">
            <span i18n class="meta-label">Inspected:</span>
            <span class="meta-value">{{ scan().inspectedTime | date: 'yyyy-MM-dd HH:mm:ss' }}</span>
          </div>

          @if (scan().modifiedTime) {
          <div nz-row nzJustify="start" nzAlign="middle">
            <span i18n class="meta-label">Changed:</span>
            <span class="meta-value">
              {{ scan().modifiedTime | date: 'yyyy-MM-dd HH:mm:ss' }}
              <span class="meta-duration">({{ scan().modifiedTime | durationFrom: scan().inspectedTime }})</span>
            </span>
          </div>
          }
          @if (scan().scanStateSetByRole) {
          <div style="display: flex; align-items: center; gap: 6px; flex-wrap: wrap;">
            <span i18n class="meta-label">Status set By:</span>
            <nz-tag [nzColor]="scan().scanStateSetByRole === 'Algo' ? 'default' : 'blue'">
              {{ scan().scanStateSetByRole }}
            </nz-tag>
            <!-- AC-5: render localized reason label next to the role tag; null → nothing -->
            @if (currentReasonLabel()) {
              <nz-tag nzColor="purple">{{ currentReasonLabel() }}</nz-tag>
            }
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

@if (scanJsonTitle()) {
  <app-json-object-preview
    [data]="scan()"
    [title]="scanJsonTitle()"
    (closed)="scanJsonTitle.set(null)"
  ></app-json-object-preview>
}

@if (tagsOpen()) {
  <app-scan-tags-popup
    [scanId]="scan().id"
    [sequenceInBatch]="scan().sequenceInBatch"
    (closed)="tagsOpen.set(false)"
  ></app-scan-tags-popup>
}

<!-- AC-1/AC-2: Operator reason-picker popup -->
<app-operator-reason-dialog
  (reasonSelected)="onReasonSelected($event)"
  (cancelled)="onReasonCancelled()"
></app-operator-reason-dialog>